import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'superUser',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/SuperUserListContainer',
      './modules/superUser'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const GroupList = require('./containers/SuperUserListContainer').default
      const actions = require('./modules/superUser')
      const reducer = require('./modules/superUser').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'superUser', reducer: reducer })

      store.dispatch(actions.fetchGroups())
      /*  Return getComponent   */
      cb(null, GroupList)

    /* Webpack named bundle   */
    }, 'superUser')
  }
})



// WEBPACK FOOTER //
// ./src/routes/SuperUser/index.js